var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('title',[_vm._v("valla")]),_vm._v(" "),_c('path',{attrs:{"fill":"#679940","d":"M28,4.5H4a1,1,0,0,0-1,1v15a1,1,0,0,0,1,1H5v6H7v-6H25v6h2v-6h1a1,1,0,0,0,1-1V5.5A1,1,0,0,0,28,4.5Zm-1,15H5V6.5H27Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fadefb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/VallasIcon.vue
// module id = null
// module chunks = 